// extracted by css-extract-rspack-plugin
export default {"dragging":"H1joB"};